import React from 'react';
import './Loader.css';

const Loader = ({ message = "Processing, please wait..." }) => {
    return (
        <div className="loader-overlay">
            <div className="loader"></div>
            <div className="loader-message">{message}</div>
        </div>
    );
};

export default Loader;
